export const TRAILING_DOC_TITLE = ' | Columbia Threadneedle Investments US'

export function setMetaDescription(content) {
  setMetaPropertyTag('omni_description', content)
  setMetaPropertyTag('og:description', content)
  setMetaTag('description', content)
}

// so hack, such sadness
// i am trying to wear a shoe as a hat
export function setMetaTag(name, content) {
  if (document.querySelector("meta[name='" + name + "']")) {
    document
      .querySelector("meta[name='" + name + "']")
      .setAttribute('content', content)
  } else {
    const meta = document.createElement('meta')
    meta.setAttribute('name', name)
    meta.setAttribute('content', content)
    document.getElementsByTagName('head')[0].appendChild(meta)
  }
}

export function setMetaPropertyTag(name, content) {
  if (document.querySelector("meta[property='" + name + "']")) {
    document
      .querySelector("meta[property='" + name + "']")
      .setAttribute('content', content)
  } else {
    const meta = document.createElement('meta')
    meta.setAttribute('property', name)
    meta.setAttribute('content', content)
    document.getElementsByTagName('head')[0].appendChild(meta)
  }
}

export function setTitle(title) {
  document.title = title + ' | Columbia Threadneedle Investments US'
}

export function setMetaTitle(content) {
  setMetaPropertyTag('omni_title', content)
  setMetaPropertyTag('og:title', content)
  setMetaTag('og-title', content)
}
